import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-phone-number-settings-list'
})
export class Ng1PhoneNumberSettingsListDirective extends UpgradeComponent {
  @Input() numbers;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('numberSettingsList', elementRef, injector);
  }
}
